import {Component, OnInit, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {register} from "swiper/element/bundle";
import {TranslateService} from "@ngx-translate/core";
import {PrimeNGConfig} from "primeng/api";
import {ActivatedRoute} from "@angular/router";
import {SettingService} from "./service/setting.service";
import {SessionToastListenerService} from "./service/session-toast-listener.service";

// Note: Swiper register() is called in constructor with platform check for SSR safety

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'test-angular';
  private isBrowser: boolean;

  constructor(
      @Inject(PLATFORM_ID) platformId: Object,
      public trans: TranslateService,
      public primeng_config: PrimeNGConfig,
      public route: ActivatedRoute,
      public setting: SettingService,
      private sessionToastListener: SessionToastListenerService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    
    // Only register Swiper in browser (it accesses DOM)
    if (this.isBrowser) {
      register();
    }
    
    this.trans.use(this.setting.lang).subscribe(() => {
      let translates = this.trans.instant('primeng_' + this.setting.lang);
      this.primeng_config.setTranslation(translates);
    });
  }

  ngOnInit() {
    // Initialize session toast listener for session warnings
    this.sessionToastListener.initialize();
  }

}
